<div class="coming-soon">
  <img [src]="'assets/images/hexa-on-develop.png' | flagUrl" alt="" />
  <div class="coming-soon__content">
    <h1>Fitur Ini Sedang Dalam Pengembangan</h1>
    <p>Biar Urusan Keagenanmu makin Lancar, Abang Lagi Siapin Sesuatu yang spesial disini, Tunggu Kabar dari Abang Segera !</p>
    <ion-button color="bg-brand-subtler" (click)="modal?.dismiss()">Tutup</ion-button>
  </div>
</div>